import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomToast = (function () {
    let currentToastId = "";
    let prevToastMsg = "";

    const ToastIcon = ({ type }) => {
        switch (type) {
            case "info":
                return (
                    <div className="msg-icon">
                        <img src={require("@app/styles/img/sendmoney.svg")} />
                    </div>
                );
            case "error":
                return (
                    <div className="msg-icon">
                        <img src={require("@shared/resources/images/error.svg")} />
                    </div>
                );

            default:
                return null;
        }
    };

    return {
        init: function () {
            return (
                <ToastContainer
                    className={"custom-toast"}
                    theme={"colored"}
                    position="top-center"
                    pauseOnFocusLoss={false}
                    icon={true}
                    closeButton={false}
                />
            );
        },
        dismiss: function (id) {
            console.log("dismiss", { id });
            toast.dismiss(id);
        },
        notify: function ({ type = "info", msg = "", options = {} }) {
            let isActive = toast.isActive(currentToastId); /* works only after the toast is rendered */
            if (currentToastId && isActive) {
                /* active toast */ console.log("active toast flow - update");
                toast.update(currentToastId, {
                    render: msg,
                    type: toast.TYPE[type.toUpperCase()]
                });
                prevToastMsg = msg;
            } else {
                /* no active toast */ console.log("no active toast flow");
                currentToastId = toast[type](msg, {
                    // onOpen: function () {
                    //     window.alert("Called when I open");
                    // },
                    onClose: function () {
                        // window.alert("Called when I close");
                        currentToastId = "";
                    },
                    toastId: "customId",
                    ...options
                });
                prevToastMsg = msg;
            }
        },
        notifyV2: function ({ type = "info", msg = "", options = {},icon }) {
            toast[type](msg,{icon:<img src={require(`@app/styles/img/${type}-toast.svg`)} />,
                // onOpen: function () {
                //     window.alert("Called when I open");
                // },
                // onClose: function () {
                //     window.alert("Called when I close");
                // },
                ...options
            });
        },
        info: function (msg) {
            this.notifyV2({ type: "info", msg:<><span className="title"> Important</span><br/>{msg}</> });
        },
        success: function (msg) {
            this.notifyV2({ type: "success", msg:<><span className="title"> Sucess</span><br/>{msg}</>  });
        },
        warn: function (msg) {
            this.notifyV2({ type: "warn", msg });
        },
        error: function (msg) {
            this.notifyV2({ type: "error", msg:<><span className="title"> Error</span><br/>{msg}</>  });
        },
        step: function (msg) {
            this.notifyV2({ type: "error", autoClose: false, msg });
        }
    };
})();

export default CustomToast;
